import { Component, OnInit } from '@angular/core';
import {AccessService} from '../services/access.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-bidding',
  templateUrl: './bidding.component.html',
  styleUrls: ['./bidding.component.css']
})
export class BiddingComponent implements OnInit {

  constructor(
      private accessService: AccessService,
      private activatedRoute: ActivatedRoute) {
  }
  parameter;

  canAccessOIA() {
    return this.accessService.canAccessOIA();
  }

  canAccessEC() {
    return this.accessService.canAccessEC();
  }

  ngOnInit() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.parameter = params['outgoingTermId'] === undefined ? '0' :  params['outgoingTermId'];
      });
  }

}
